import PropTypes from 'prop-types';
import { withApollo } from '@apollo/client/react/hoc';
import { Formik } from 'formik';
import NewEmailInvitesForm, { newEmailInvitesSchema } from '../new-email-invites-form';
import { createGroupEmailInvitesMutation, groupInvitesQuery } from '../../apollo/groups';
import { splitEmailInvitesBody } from '../../utils/invites';

const NewGroupEmailInvites = ({ group, client, disabled }) => {
  return (
    <Formik
      initialValues={{
        body: ''
      }}
      validationSchema={newEmailInvitesSchema}
      onSubmit={(values, actions) => {
        client.mutate({
          mutation: createGroupEmailInvitesMutation,
          variables: {
            groupId: group.id,
            emails: splitEmailInvitesBody(values.body)
          },
          update: (proxy, { data: { createGroupEmailInvites: newInvites } }) => {
            const listVariables = { slug: group.slug };
            const data = proxy.readQuery({
              query: groupInvitesQuery,
              variables: listVariables
            })
            proxy.writeQuery({
              query: groupInvitesQuery,
              data: {
                ...data,
                group: {
                  ...data.group,
                  emailInvites: [...newInvites, ...data.group.emailInvites]
                }
              },
              variables: listVariables
            })
          }
        }).then(() => {
          actions.setSubmitting(false);
          actions.resetForm();
        }).catch((error) => {
          actions.setSubmitting(false);
          console.log(error);
          // actions.setErrors();
          // actions.setStatus();
        });
      }}
    >
      {(props) => <NewEmailInvitesForm {...props} disabled={disabled} />}
    </Formik>
  );
}

NewGroupEmailInvites.propTypes = {
  group: PropTypes.object,
  disabled: PropTypes.bool,
  client: PropTypes.object
};

export default withApollo(NewGroupEmailInvites);
